/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function BriefcaseMetal(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Rect x={24} y={120} width={208} height={48} />
        <Path d="M24,184v24a16.01833,16.01833,0,0,0,16,16H216a16.01833,16.01833,0,0,0,16-16V184Z" />
        <Path d="M232,104V80a16.01833,16.01833,0,0,0-16-16H176V56a24.0275,24.0275,0,0,0-24-24H104A24.0275,24.0275,0,0,0,80,56v8H40A16.01833,16.01833,0,0,0,24,80v24ZM96,56a8.00917,8.00917,0,0,1,8-8h48a8.00917,8.00917,0,0,1,8,8v8H96Z" />
      </G>
    </Svg>
  );
}

export default BriefcaseMetal;
